<template>
  <div :class="['register-overlay', { active: showRegister }]">
    <div class="register-popup">
      <button class="close-button" aria-label="关闭" @click="emit('close')">
        <AppIcon name="close" size="sm" aria-label="" />
      </button>

      <div class="logo">
        <img :src="BRAND_ASSETS.logo" alt="Logo" />
      </div>

      <ErrorMessage v-if="apiError" :message="apiError" />

      <form class="register-form" @submit.prevent="submitForm">
      <div class="input-group auth-field-phone">
        <input
          id="mobile"
          type="tel"
          placeholder="请输入手机号"
          aria-label="手机号"
          v-model="mobile"
          @blur="validateMobile"
          maxlength="11"
          :class="{ 'input-error': mobileError, 'input-animated': mobileError }"
        />
        <span v-if="mobileError" class="error-message">{{ mobileError }}</span>
      </div>

      <div class="input-group auth-field-slider">
        <SliderVerify
          ref="sliderVerifyRef"
          @verify-success="handleVerifySuccess"
        />
      </div>

      <div class="input-group auth-field-verify">
        <div class="verify-code-row">
          <input
            id="verifyCode"
            type="text"
            placeholder="请输入6位验证码"
            aria-label="验证码"
            v-model="verifyCode"
            @blur="validateVerifyCode"
            maxlength="6"
            :class="verifyCodeInputClass"
          />
          <button
            type="button"
            class="send-code-btn"
            :disabled="sendCodeDisabled"
            @click="sendVerifyCode"
          >
            {{ sendCodeBtnText }}
          </button>
        </div>
        <span
          v-if="verifyCodeFieldError"
          class="error-message auth-verify-code-api-msg"
          >{{ verifyCodeFieldError }}</span>
        <span v-else-if="verifyCodeError" class="error-message">{{
          verifyCodeError
        }}</span>
      </div>

      <button
        type="submit"
        class="register-button"
        :disabled="isFormInvalid"
      >
        立即注册
      </button>
      </form>

      <p class="login-prompt">
        已有账号？
        <a href="#" class="login-link" @click.prevent="emit('show-login')"
          >现在登录</a
        >
      </p>
    </div>
  </div>
</template>

<script setup>
import ErrorMessage from '@/shared/components/ErrorMessage.vue'
import SliderVerify from '@/shared/components/SliderVerify.vue'
import AppIcon from '@/shared/components/AppIcon.vue'
import { BRAND_ASSETS } from '@/shared/assets/manifest'
import { useRegister } from '@/features/user/composables/useRegister'

const props = defineProps({
  showRegister: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'show-login', 'register-success'])

const {
  mobile,
  verifyCode,
  mobileError,
  verifyCodeError,
  verifyCodeFieldError,
  apiError,
  sliderVerifyRef,
  isFormInvalid,
  sendCodeDisabled,
  sendCodeBtnText,
  verifyCodeInputClass,
  validateMobile,
  validateVerifyCode,
  sendVerifyCode,
  submitForm,
  handleVerifySuccess,
} = useRegister(props, emit)
</script>

<style scoped src="@/features/user/styles/Register.css"></style>
